import { AzureDevOpsBranch, AzureDevOpsRepo, AzureDevOpsTreeEntry } from '../../models/azure-dev-ops';
import { createStringIdAdapter } from './common/string-id-adapter';

export const azureDevOpsRepoAdapter = createStringIdAdapter<AzureDevOpsRepo>();

export const azureDevOpsBranchesAdapter = createStringIdAdapter<AzureDevOpsBranch[]>();

export const azureDevOpsRepoContentsAdapter = createStringIdAdapter<AzureDevOpsTreeEntry[]>();
